import * as React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { NavigationLink } from '../../Links/Links';
import NavigationContent from './NavigationContent';
import MenuBackground from '../../Overlay';
import { onSaleParam, newInParam } from '../../../helpers';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

const SalesNewIn: React.ComponentType<{
  sales: boolean;
  navIndex: string;
  menuToRender: any;
  hoverLeftImg: object;
  hoverRightImg: object;
  department: string;
  buildUrlWithCountry: (route: string) => string;
  getColor: (color: string) => string;
  setNavIndex: (index?: string) => string;
}> = ({ sales, navIndex, menuToRender, hoverLeftImg, hoverRightImg, department, getColor, buildUrlWithCountry, setNavIndex }) => {
  const index = sales ? 'sales' : 'newIn';
  const title = sales ? 'sale' : 'new in';

  return (
    <div
      style={{ position: 'relative' }}
      onFocus={() => {}}
      onMouseOver={() => setNavIndex(index)}
      onMouseLeave={() => setNavIndex()}
    >
      <CSSTransitionGroup transitionName="fade-nav" transitionAppear transitionEnter={false} transitionLeave={false}>
        <NavigationLink
          key={index}
          padding="0 15px"
          underline={navIndex === index}
          color={sales ? '#FF0000' : getColor(index)}
          hoverColor={sales ? '#FF0000' : '#000'}
          cursor="pointer"
          href={buildUrlWithCountry(`${menuToRender.url}/?${sales ? onSaleParam : newInParam}`)}
        >
          <span>{title}</span>
        </NavigationLink>
      </CSSTransitionGroup>
      {navIndex === index && (
        <React.Fragment>
          <NavigationContent
            hoverLeftImg={hoverLeftImg}
            hoverRightImg={hoverRightImg}
            values={menuToRender}
            newIn={index === 'newIn'}
            sales={index === 'sales'}
            department={department}
          />
          <MenuBackground pointerEvents="none" />
        </React.Fragment>
      )}
    </div>
  );
};

export default withCountryCode(SalesNewIn);
